import React, { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import axios from "../axiosSetup";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import "./UserControllerModal.css";

const UserControllerModal = ({ open, onClose, user }) => {
  const [customers, setCustomers] = useState([]);
  const [allCustomers, setAllCustomers] = useState([]);
  const [selected, setSelected] = useState([]);
  const [initialSelected, setInitialSelected] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && user?.id) {
      loadCustomers();
    }
  }, [open, user?.id]);

  /* ---------------- LOAD CUSTOMERS ---------------- */
const loadCustomers = async () => {
  try {
    setLoading(true);

    // CHANGED: using GET instead of POST, passing userId as query param
    const res = await axios.get("/user/dropdown/customers", {
      params: {
        userId: user.id,
      },
    });

    const data = res.data || [];

    setAllCustomers(data);
    setCustomers(data);

    const mapped = data.filter(c => c.isMapped).map(c => c.id);
    setSelected(mapped);
    setInitialSelected(mapped);

  } catch (err) {
    console.error("Error loading customers:", err);
    setCustomers([]);
    setAllCustomers([]);
    setSelected([]);
    setInitialSelected([]);
  } finally {
    setLoading(false);
  }
};


  /* ---------------- HELPERS ---------------- */
  const isSameSelection = (a, b) => {
    if (a.length !== b.length) return false;
    return a.every(id => b.includes(id));
  };

  /* ---------------- UPDATE ---------------- */
  const handleUpdate = async () => {

    //No customer selected
    // if (selected.length === 0) {
    //   alert("Please select at least one customer.");
    //   return;
    // }

    //No changes made
    if (isSameSelection(selected, initialSelected)) {
      alert("No changes detected. Please modify customer selection before updating.");
      return;
    }

    try {
      setLoading(true);

      await axios.post("/user/add-customers", {
        userId: user.id,
        customers: selected,
      });

      onClose();

    } catch (err) {
      console.error("Error updating user customers:", err);
      alert("Failed to update customers");
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- SELECTION ---------------- */
  const toggleAll = (checked) => {
  const visibleIds = customers.map(c => c.id);

  setSelected(prev => {
    if (checked) {
      // add visible customers to selection
      return Array.from(new Set([...prev, ...visibleIds]));
    } else {
      // remove ONLY visible customers
      return prev.filter(id => !visibleIds.includes(id));
    }
  });
};


  const toggleOne = (id) => {
    setSelected(prev =>
      prev.includes(id)
        ? prev.filter(x => x !== id)
        : [...prev, id]
    );
  };

  if (!open) return null;

  return (
    <div className="uc-overlay">
      <div className="uc-popup">

        {/* HEADER */}
        <div className="uc-header">
          <div>
            <h3>User Customer Controller</h3>
            <p className="uc-subtitle">
              Editing access for <strong>{user?.name}</strong>
            </p>
          </div>
          <FiX className="uc-close" onClick={onClose} />
        </div>

        {/* SEARCH */}
        <div className="uc-search">
          <input
            type="text"
            placeholder="Search customers..."
            onChange={(e) => {
              const q = e.target.value.toLowerCase();
              setCustomers(
                q
                  ? allCustomers.filter(c =>
                      c.name.toLowerCase().includes(q)
                    )
                  : allCustomers
              );
            }}
          />
        </div>

        {/* SELECT ALL */}
        <label className="uc-row uc-select-all">
          <input
            type="checkbox"
            checked={
              customers.length > 0 &&
              customers.every(c => selected.includes(c.id))
            }
            onChange={(e) => toggleAll(e.target.checked)}
          />
          <span>Select All</span>
        </label>

        {/* LIST */}
        <div className="uc-list">
          {loading ? (
            <div style={{ minHeight: "140px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 10 }}>
              <Spin indicator={<LoadingOutlined style={{ fontSize: 28, color: "#f50087" }} spin />} />
              <span style={{ color: "#f50087", fontWeight: 600 }}>Loading</span>
            </div>
          ) : customers.length > 0 ? (
            customers.map(c => (
              <label key={c.id} className="uc-row">
                <input
                  type="checkbox"
                  checked={selected.includes(c.id)}
                  onChange={() => toggleOne(c.id)}
                />
                <span className="uc-name">{c.name}</span>
              </label>
            ))
          ) : (
            <div className="uc-empty">No customers found.</div>
          )}
        </div>

        {/* ACTIONS */}
        <div className="uc-actions">
          <button className="uc-btn cancel" onClick={onClose}>
            Cancel
          </button>

          <button
            className="uc-btn update"
            disabled={loading}
            onClick={handleUpdate}
          >
            {loading ? "Updating..." : "Update"}
          </button>
        </div>

      </div>
    </div>
  );
};

export default UserControllerModal;
